import _ from 'lodash';
import { v6 as uuidV6 } from 'uuid';
import { isEmptyObject } from '../../helper/utils/isEmptyObject.js';
import { doError } from '../responseHandling/responseHandling.actions.js';
import { doHandleState, doSetData } from './onlineSales.actions.js';
import OnlineSalesProvider from './onlineSales.apis.js';

const OnlineSalesService = {
    doGetProductsAvailability: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingOrder', true));
        dispatch(doSetData([]));

        const { acknowledge, data, message } = await OnlineSalesProvider.doGetProductsAvailability(payload);

        if (acknowledge && acknowledge === 1) {
            dispatch(doSetData(data));
            dispatch(doHandleState('loadingOrder', false));
        } else {
            dispatch(doError(message, '', 'Get List'));
            dispatch(doHandleState('loadingOrder', false));
            dispatch(doSetData([]));
        }
    },

    doGetProductsDaysAvailability: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingDetail', true));
        dispatch(doHandleState('detail', {}));

        const { acknowledge, data, message } = await OnlineSalesProvider.doGetProductsDaysAvailability(payload);
        if (acknowledge && acknowledge === 1) {
            dispatch(doHandleState('loadingDetail', false));

            const detail = data || {};
            const availabilities = detail['availability'] || [];
            const currentDate = payload['date'] || formattedDate3(new Date());
            const getAvailability = availabilities.find((item) => item.date === currentDate);
            const isActive = ((getAvailability || {})['availability'] || '') == 'available';

            dispatch(doHandleState('availabilityStatusActive', isActive));
            dispatch(
                doHandleState('detail', {
                    ...detail,
                    packages: (detail['packages'] || []).map((pkg) => {
                        return {
                            ...pkg,
                            id: uuidV6(),
                            details: (pkg['details'] || []).map((dtl) => {
                                return {
                                    ...dtl,
                                    id: uuidV6(),
                                    brandCode: pkg['brandCode'] || '',
                                    menuCode: dtl['menuCode'] || '',
                                    menuName: dtl['menuPackageItemName'] || '',
                                    duration: '1',
                                    taxOn: '1',
                                    vatInclusiveFlag: '1',
                                    isOnlineSales: '2',
                                    imageUrl: dtl['imageUrl'] || '',
                                    cateCode: dtl['cateCode'] || '',
                                    groupCode: dtl['groupCode'] || '',
                                    basePrice: dtl['additionalPrice'] || '',
                                    vatPrice: dtl['vatPrice'] || '',
                                    isNeedTimeSlot: '0',
                                    isRecurring: '0',
                                    isParentMenu: '0',
                                    menuType: 'packages',
                                };
                            }),
                        };
                    }),
                    detail: {
                        ...detail['detail'],
                        id: uuidV6(),
                    },
                }),
            );
            dispatch(doHandleState('selectedDetailRooms', []));
            dispatch(doHandleState('selectedAddonsDetail', []));
        } else {
            dispatch(doError(message, '', 'Get List'));
            dispatch(doHandleState('loadingDetail', false));
            dispatch(doHandleState('detail', {}));
        }
    },
    doHandleGeneratePaymentLink:
        (payload, orderCategory = 'TICKETING', payloadParty = {}) =>
        async (dispatch) => {
            dispatch(doHandleState('loadingOrder', true));
            const latestOrder = JSON.parse(localStorage.getItem('order') || '[]');
            const latestPayment = JSON.parse(localStorage.getItem('payment') || '[]');

            const { acknowledge = 0, data = {}, message = '' } = await OnlineSalesProvider.doPostCreatePaymentLink(payload, orderCategory, payloadParty);

            if (+acknowledge === 1) {
                const { paymentUrl } = data;

                if (latestOrder.length <= 10 || latestPayment <= 10) {
                    localStorage.setItem('order', JSON.stringify([...latestOrder, payload]));
                    localStorage.setItem('payment', JSON.stringify([...latestPayment, data]));
                }

                dispatch(doHandleState('cart', []));
                dispatch(doHandleState('waiver', {}));
                dispatch(doHandleState('minor', []));
                dispatch(doHandleState('selectedDate', ''));
                dispatch(doHandleState('brands', []));
                dispatch(doHandleState('outlets', {}));

                // window.location.reload();
                window.open(paymentUrl['redirect_url'], '_self');

                dispatch(doHandleState('loadingOrder', false));
                return;
            }

            window.alert(message);
            dispatch(doHandleState('loadingOrder', false));
        },

    doHandleGetBrands: (payload) => async (dispatch) => {
        dispatch(doHandleState('loadingBrand', true));
        dispatch(doHandleState('brands', {}));
        dispatch(doHandleState('outlets', []));

        const response = await OnlineSalesProvider.doGetBrands(payload);
        const { acknowledge = 0, data = {} } = response;

        if (+acknowledge === 1) {
            const { onSuccess = null } = payload || {};

            dispatch(doHandleState('loadingBrand', true));

            if (!isEmptyObject(data)) {
                const outletDesc = {
                    PIM: {
                        outletName: 'PIM',
                        desc: 'Pondok Indah Mall',
                    },
                    PURI: {
                        outletName: 'PURI',
                        desc: 'Puri Indah Mall',
                    },
                    GMB: {
                        outletName: 'GRAND METRO BEKASI',
                        desc: 'Grand Metro Bekasi',
                    },
                    TSB: {
                        outletName: 'BINTARO',
                        desc: 'Lotte Mall Bintaro',
                    },
                    IDHQ: {
                        outletName: 'DREAM US HQ',
                        desc: 'Dream Us Headquarters',
                    },
                    KOKAS: {
                        outletName: 'KOKAS',
                        desc: 'Kota Kasablanka',
                    },
                    PVJ: {
                        outletName: 'PVJ',
                        desc: 'Paris Van Java',
                    },
                };

                const mappingOutlets = {
                    ...data,
                    outlets: data['outlets'].map((outlet) => {
                        return {
                            ...outlet,
                            ...outletDesc[outlet['outletName']],
                        };
                    }),
                };

                dispatch(doHandleState('brands', mappingOutlets));
                dispatch(doHandleState('outlets', mappingOutlets['outlets']));

                localStorage.setItem('outlets', JSON.stringify(mappingOutlets['outlets']));
                localStorage.setItem('brand', JSON.stringify(data));

                if (typeof onSuccess === 'function') {
                    onSuccess(mappingOutlets);
                }

                setTimeout(() => {
                    dispatch(doHandleState('loadingBrand', false));
                }, 2000);
            }

            return;
        }
    },

    doHandleGetOutlets: () => async (dispatch) => {
        const response = await OnlineSalesProvider.doGetOutlets();
        const { acknowledge = 0, data = [] } = response;

        if (+acknowledge === 1) {
            dispatch(doHandleState('outlets', data));
            return;
        }
    },

    doHandleGetHistoryTransactions: () => async (dispatch) => {
        const response = await OnlineSalesProvider.doGetHistoryTransaction();
        const { acknowledge = 0, data = [], dataTrxOnline = [] } = response;

        if (+acknowledge === 1) {
            const histories = [...dataTrxOnline, ...data].map((history) => {
                return {
                    ...history,
                    id: history['billNo'] || '',
                };
            });

            const sortByDate = _.orderBy(histories, ['billDate'], ['desc']);

            dispatch(doHandleState('historyTransactions', sortByDate));
            return;
        }
    },

    doHandleGetHistoryTransactionDetail:
        (billNo = '', orderType = 'REGULAR') =>
        async (dispatch) => {
            const response = await OnlineSalesProvider.doGetHistoryTransactionDetail(billNo, orderType);
            const { acknowledge = 0, data = {} } = response;

            if (+acknowledge === 1) {
                dispatch(doHandleState('historyTransactionDetail', data));
                return;
            }
        },

    doHandleGetLoyaltyTier: () => async (dispatch) => {
        const response = await OnlineSalesProvider.doGetLoyaltyTier();

        const { acknowledge = 0, data = [] } = response;

        if (+acknowledge === 1) {
            dispatch(doHandleState('loyaltyTiers', data));
            return;
        }
    },

    doHandleGetAvailableRewards: () => async (dispatch) => {
        const response = await OnlineSalesProvider.doGetAvailableRewards();

        const { acknowledge = 0, data = {} } = response;

        if (+acknowledge === 1) {
            dispatch(doHandleState('rewardsData', data));
            return;
        }
    },

    doHandleGetPointHistory: () => async (dispatch) => {
        const response = await OnlineSalesProvider.doGetPointHistory();

        const { acknowledge = 0, data = [] } = response;

        if (+acknowledge === 1) {
            dispatch(doHandleState('pointHistory', data));
            return;
        }
    },

    doHandleGetRedeemHistory: () => async (dispatch) => {
        const response = await OnlineSalesProvider.doGetRedeemHistory();

        const { acknowledge = 0, data = [] } = response;

        if (+acknowledge === 1) {
            dispatch(doHandleState('redeemHistory', data));
            return;
        }
    },

    doHandleTriggerRedeem: (payload, onSuccess) => async (dispatch) => {
        dispatch(doHandleState('loadingPoints', true));
        const response = await OnlineSalesProvider.doPostTriggerRedeem(payload);

        const { acknowledge = 0, message = '' } = response;

        if (+acknowledge === 1) {
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        } else {
            dispatch(doError(message, '', 'Trigger Redeem'));
        }
        dispatch(doHandleState('loadingPoints', false));
    },
};

export default OnlineSalesService;
